module.exports = __webpack_public_path__ + "fonts/SFUIText-Semibold.f77b7220.eot";